export default "__VITE_ASSET__DZwmL9qt__"